<div class="details-container">
  <div
    class="details-header"
    style="background: url(assets/images/bex2.jpg)"
  >
    <div class="details-banner">
      <h1>Bexley Grammar Schools</h1>
      <h2>11 Plus (11+) Exam Informatio</h2>
    </div>
  </div>

  <div class="details-publisher">
    <span><strong>Published by - SEHYOG Academy</strong></span>
  </div>

  <div class="details-content">
    <div class="details-section">
      <h3>Introduction</h3>

      <div class="spacer"></div>

      <p>
        Grammar school consortia in the UK are collaborative groups of grammar
        schools that work together to administer entrance exams. They are
        typically formed by a group of grammar schools in a particular area or
        region, who have come together to create a common entrance examination.
        This test is known as the 11+ or eleven plus exam, and is taken by
        students seeking Year 7 entry into these selective schools. <br />
        <br />

        Since its inception, the Bexley Grammar School Consortium has played a
        vital role in the selective education system catering to students in
        Bexley, offering a standardised process for admitting students based on
        their academic abilities. <br />
        <br />

        All the schools within the Bexley Grammar School Consortium utilise the
        same entrance test, ensuring fairness in the admissions process.
        Consequently, students only need to take the test once, even if they are
        applying to multiple schools within the consortium. <br />
        <br />

        The primary objective of the Bexley Consortium is to streamline the
        admissions process for its grammar schools and ensure consistency in the
        selection process. The grammar schools within the consortium
        collaborate, sharing resources, expertise and administrative efforts
        with the aim of providing equal opportunities for students from diverse
        backgrounds to pursue a high-quality education.
      </p>

      <div class="spacer"></div>

      <h2>Complete List of Grammar Schools in Bexley</h2>

      <p>
        There are currently four grammar schools in the Bexley Grammar School
        Consortium:
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <table>
        <tr>
          <th>School Name</th>
        </tr>
        <tr *ngFor="let school of schools">
          <td>
            <a [href]="school.url" target="_blank">{{ school.name }}</a>
          </td>
        </tr>
      </table>

      <div class="spacer"></div>

      <p>⬇️ Read on to learn more about their exam and admissions process!</p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>11 Plus (11+) Exam Information for Bexley Grammar Schools</h2>

      <p>
        Bexley Consortium entrance exam results form a common basis for
        admission decisions among participating grammar schools. Students who
        demonstrate excellent performance in the examination are eligible for
        consideration for admission to various schools within the consortium,
        thereby enhancing their prospects of securing a place at a grammar
        school. Here are key details about the Bexley 11+ exam:
      </p>

      <p><strong>Registration closing date: </strong> June</p>
      <p>
        <strong>Common Application Form (CAF) closing date:</strong> October
      </p>
      <p><strong>Exam date:</strong> September</p>
      <p><strong>Exam board type:</strong>GL Assessment</p>
      <p>
        <strong>Pass mark: </strong> Aim for 80%+ in our practice tests. See
        below for more details.
      </p>
      <p><strong>Results date:</strong>October</p>
      <p><strong>Allocations date: </strong>March</p>
      <p>
        <strong>Admissions info: </strong> London Borough of Bexley, 0208 303
        7777
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Bexley Grammar Schools 11 Plus (11+) Admissions</h2>

      <div class="spacer"></div>

      <p>
        All four grammar schools adhere to the Bexley Coordinated Secondary
        School Admissions Scheme. Only children who pass the Bexley entrance
        test can be considered for admission in Year 7. However, parents should
        be aware that achieving the necessary pass mark in the 11+ exam isn’t a
        guarantee of a Year 7 place at a Bexley grammar school. <br />
        <br />

        As part of the admissions process, you and your child are invited to
        attend Open Days at your preferred school. These events will provide you
        with the opportunity to tour facilities, meet members of staff and talk
        to current pupils. <br />
        <br />

        To be considered for a Year 7 place at a Bexley grammar school, you must
        first register your child for the eleven plus exam.
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>How to Register for the Bexley Grammar Schools 11 Plus (11+) Exam</h2>
      <div class="spacer"></div>

      <p>
        To apply for a Year 7 place at a Bexley grammar school on behalf of your
        child, you must complete an online application form via your Local
        Authority (LA) before the closing date in June. In addition, you will be
        required to fill out the Common Application Form (CAF) and indicate your
        preferred school/schools. The deadline for this is in October.
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Bexley Grammar Schools 11 Plus (11+) Exam Format</h2>

      <div class="spacer"></div>

      <p>
        he Bexley 11+ exam consists of two multiple-choice papers, each lasting
        approximately 50 minutes. <br />
        <br />

        ⇒ Test 1: Verbal Skills – Comprehension, Technical English & SPAG,
        Verbal Reasoning <br />
        <br />

        Consists of two sections ➤ The paper begins with a reading passage,
        followed by a series of comprehension questions. Then there are
        questions that test two of the following three topics: Spelling,
        Punctuation and Sentence Completion. A subsequent Verbal Reasoning
        section evaluates your child’s ability to discern rules and
        relationships between words and letters. <br />
        <br />

        ⇒ Test 2: Mathematics & Non-Verbal Reasoning (with elements of Spatial
        Reasoning) <br />
        <br />

        Consists of two sections ➤ Section 1 covers Mathematics questions that
        assess students’ mathematical skills, problem-solving abilities and
        logical reasoning. Section 2 is broken down into multiple timed
        subsections that assess Non-Verbal Reasoning (NVR) and Spatial
        Reasoning. NVR questions test students’ ability to solve problems using
        visual and abstract reasoning. Spatial Reasoning tests spatial
        awareness, mental rotation, visualisation and problem-solving skills.
        <br />
        <br />
      </p>

      <p>
        Students will be given a separate age-standardised score for each of the
        three subject areas: <br />
        <br />

        1. Verbal Ability – Comprehension, Technical English and VR 2. Numerical
        Ability – Mathematics 3. Non-Verbal Ability – NVR and Spatial Reasoning

        <br />
        <br />

        One total age-standardised score will then be used to decide whether
        your child is eligible for entry. The total score is weighted, by
        combining 50% of the Verbal Ability score, 25% of the Numerical Ability
        score and 25% of the Non-Verbal Ability score.
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Bexley 11 Plus (11+) Exam Pass Marks and Target Scores</h2>

      <div class="spacer"></div>

      <p>
        The scores are age-standardised and take into account the number of
        available places. The minimum standardised score to be achieved is 216,
        while top applicants typically score over 246. <br />
        <br />

        Pupils who are able to score 80%+ consistently in our 11+ practice tests
        are on track to pass the Bexley 11 Plus. <br />
        <br />

        Whilst there are no guarantees, this has historically been a fairly
        strong indicator that your child should do well in the Bexley 11+ exam.
        <br />
        <br />

        Passing the test does not guarantee that your child will be offered a
        place. It simply means they have surpassed the required threshold. As
        such, it makes sense to aim for as high a score as possible. <br />
        <br />

        Don’t worry if your child is not scoring well in our practice papers
        from the outset. With targeted practice and focus, it’s possible to make
        big improvements in a short amount of time!
      </p>

      <h2>Bexley Grammar Schools: Results & Leavers’ Destinations</h2>

      <p>
        <strong>Bexley Grammar Schools – Progress 8 Scores</strong> <br />
        <br />

        Progress 8 is a metric used to measure the advancement students make
        from primary school (the end of Key Stage 2) to secondary school (the
        end of Key Stage 4). It provides insight into the educational value
        schools provide by evaluating students’ academic progress. <br />
        <br />

        To calculate the Progress 8 score, the actual achievements of students
        in eight core subjects, such as English, mathematics, sciences,
        humanities, and languages, are compared to their expected achievements.
        These expectations are based on their prior attainment at the end of
        primary school. The score is determined by the average progress students
        make across these subjects.
      </p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Bexley Grammar Schools – Leavers’ Destinations</h2>

      <p>
        Leavers’ destinations here refer to the next steps that students take
        after completing their studies at Bexley grammar schools. <br />
        <br />

        Russell Group universities are widely renowned institutions, acclaimed
        for their outstanding performance against various key indicators. These
        universities exhibit exceptional research output, housing eminent
        scholars and groundbreaking discoveries. Their academic standing is
        exemplary, attracting talented individuals from across the world. <br />
        <br />

        Among the esteemed Russell Group members are the University of Oxford
        and the University of Cambridge, both renowned for their historic
        legacy, academic eminence and rigorous educational offerings. With
        illustrious faculty and a commitment to excellence, these universities
        have maintained their prestigious status for centuries.
      </p>

      <h2>
        Frequently Asked Questions About The 11 Plus (11+) Bexley Grammar School
        Consortium
      </h2>

      <p>
        <strong>Does Bexley have grammar schools?</strong>
         <br />
        <br />

        Yes, Bexley has four selective grammar schools. Click here to access the
        articles we have for each of these schools, addressing their history and
        ethos, as well as all the details about their 11+ entry procedure.
        <br />
        <br />

        <strong>When should students register for the Bexley 11+ exam?</strong> <br />
        <br />

        The deadline to register via the Local Authority is in June of the year
        preceding entry. A Common Application Form must also be submitted,
        indicating your preferred school/schools. The deadline for this is in
        October. <br />
        <br />

        <strong>When do grammar schools in Bexley hold their 11+ exam?</strong> <br />
        <br />

        Grammar schools in the Bexley Consortium hold their 11+ exam in
        September. <br />
        <br />

        <strong>What is the format of the Bexley 11+ exam?</strong> <br />
        <br />

        The Bexley test consists of two multiple-choice papers, each lasting
        approximately 50 minutes. The papers cover the following subject areas:
        English (Comprehension & Technical English), Verbal Reasoning,
        Mathematics and Non-Verbal Reasoning (including Spatial Reasoning).
        <br />
        <br />

        <strong>What is the pass mark at Bexley grammar schools?</strong> <br> <br> 

        The minimum
        standardised score to be achieved is 216, while top applicants typically
        score over 246. Pupils who are able to score 80%+ consistently in our
        11+ practice tests should be on track to pass the Bexley 11 Plus.
        <br> <br>
        <strong>Who isthe 11+ exam provider for Bexley?</strong> <br />
        <br />

        Bexley’s grammar schools use GL Assessment as their 11+ exam provider.
      </p>

      <div class="spacer"></div>
    </div>
  </div>
</div>
